import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { Image } from 'react-bootstrap';

import LoadingComponent from '../../../core/LoadingComponent/LoadingComponent'
import CompatibilityPanelGroupCompnent from './CompatibilityPanelGroupComponent'

import './compatibility.scss';

class CompatibilityComponent extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            activeKey: null,
        };
        this.initialDataState = {};

        this.initialDataState['apis'] = null;
        this.initialDataState['commonApis'] = null;
        this.initialDataState['consoleSpecificApis'] = null;

        this.state = this.initialState;
    }

    componentWillMount() {
        const { isLoading, getCompatibilityMapping } = this.props

        if (!isLoading) {
            getCompatibilityMapping();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.apis) {
            this.initialState['apis'] = nextProps.apis;
            this.initialState['commonApis'] = nextProps.commonApis;
            this.initialState['consoleSpecificApis'] = nextProps.consoleSpecificApis;

            this.setState(this.initialState);
        }
    }

    handleSelect = (activeKey) => {
        this.setState({ activeKey });
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Compatibility Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { isLoading, apis, commonApis, consoleSpecificApis } = this.props;
        const { activeKey } = this.state;

        const thumbnails = {
            'Discover SE and Discover SI Only': ['discover-se-console.png', 'discover-si-console.png'],
            'Discover SE3 and Discover SE3HD Only': ['discover-se3-console.png', 'discover-se3-hd-console.png'],
        }

        const titles = {
            'Discover SE and Discover SI Only': 'Discover SE / SI Only',
            'Discover SE3 and Discover SE3HD Only': 'Discover SE3 / SE3 HD Only',
        }

        if (isLoading) {
            return <LoadingComponent fullScreen />;
        }

        return <div className="compatibility-component">
            <div className="compatibility-component">
                <h3>API Compatibility</h3>
                <p>View APIs that are universally compatible with, or specific to, our equipment consoles.</p>

                <h4>Compatible with all consoles</h4>
                {apis && <CompatibilityPanelGroupCompnent
                    allApis={apis}
                    apisToShow={commonApis}
                    activeKey={activeKey}
                    handleSelect={this.handleSelect}
                    panelKey={'allApis'}
                />}

                {apis && Object.keys(consoleSpecificApis).map((key) => {
                    return <div key={key}>
                        <h4>
                            {thumbnails[key].map((imageurl) => {
                                return <Image key={imageurl} className="console-thumbails" src={require(`./images/${imageurl}`)} />;
                            })}
                            {titles[key]}
                        </h4>
                        <CompatibilityPanelGroupCompnent
                            allApis={apis}
                            apisToShow={consoleSpecificApis[key]}
                            activeKey={activeKey}
                            handleSelect={this.handleSelect}
                            panelKey={key}
                        />
                    </div>
                })}
            </div>
        </div>;
    }
};

CompatibilityComponent.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    getCompatibilityMapping: PropTypes.func.isRequired,
    apis: PropTypes.object.isRequired,
    commonApis: PropTypes.object.isRequired,
    consoleSpecificApis: PropTypes.object.isRequired,
};

export default CompatibilityComponent;



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Compatibility/CompatibilityComponent.js